/**
 * The window a name dropped on a crew group will cover: the group's first
 * open slot when it has one (that slot's own phase and shift), else the
 * step's own window on that day. Hours are decimal hours into the day as
 * the lane rows carry them; 24 means midnight at the end of the day.
 */
import { addMinutes, parseISO } from "date-fns";

import { toLocalIso } from "../../../utils/time";
import { LaneCrewGroup, LaneStep } from "./lane-rows";

export interface PlaceWindow {
	start: string;
	end: string;
	phaseId: number | null;
}

export const isoAt = (dayIso: string, hours: number): string => toLocalIso(addMinutes(parseISO(dayIso), Math.round(hours * 60)));

export function placeWindow(dayIso: string, step: Pick<LaneStep, "start" | "end">, group: Pick<LaneCrewGroup, "slots" | "dropPhaseId" | "start" | "end">): PlaceWindow {
	const slot = group.slots[0];
	if (slot) {
		return { start: slot.startIso, end: slot.endIso, phaseId: slot.phaseId };
	}
	// A full group: the group's own window when it has one, else the step's.
	const start = group.end > group.start ? group.start : step.start;
	const end = group.end > group.start ? group.end : step.end;
	return { start: isoAt(dayIso, start), end: isoAt(dayIso, end), phaseId: group.dropPhaseId };
}
